import React from "react";

const RFIDocuments = () => <div>Documents content gonna be here</div>;

export default React.memo(RFIDocuments);
